import { createActions } from 'redux-actions';
import { Pagination } from '@models/Pagination';
import { PolicyCommissionInvoiceList } from '@models/PolicyCommissionInvoice';
import { GetAllPolicyCommissionInvoiceParams } from '@apis/PolicyCommissionInvoiceApi';

export type State = {
  invoices?: PolicyCommissionInvoiceList[] | null;
  pagination?: Pagination;
  isLoading: boolean;
};

export type PolicyCommissionInvoicesFetchPayload = GetAllPolicyCommissionInvoiceParams;
export type StateUpdatePayload = Partial<State>;

export const {
  policyCommissionInvoicesFetch,
  stateUpdate,
} = createActions(
  'POLICY_COMMISSION_INVOICES_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'POLICY_COMMISSION_INVOICE_LIST_PAGE',
  },
);
